export default __webpack_public_path__ + "static/media/right-quote.c38e0a44.svg";